<template>
    <div fluid fill-height >
      <v-expand-x-transition>
        <landing-toolbar />
      </v-expand-x-transition>
      <v-container style="min-width:95% !important;overflow: hidden;">
        <Liquidations />
      </v-container>
    </div>
</template>
  
  <script>

  import LandingToolbar from '../../components/LandingToolbar/LandingToolbar.vue'
  import Liquidations from '../../components/Liquidaciones/Liquidations'
  export default {
    components: { Liquidations, LandingToolbar },
  };
  </script>

